import { v1 } from 'uuid';
import { hasOwnProperty } from '@/utils/misc';

export default class HeatMapLayer {
    constructor(group, zoomRange) {
        this._map = null;
        this._id = v1();
        this._source = null;
        this._group = group;
        this._zoomRange = zoomRange;
    }

    get id() {
        return ['point', 'heat'].map(name => {
            return this._id + '.' + name;
        });
    }
    get sourceId() {
        return this._id + '.' + 'source';
    }

    eachLayer(callback) {
        if (this._map) {
            ['point', 'heat'].forEach((name, index) => {
                const layer = this._map.getLayer(this._id + '.' + name);
                if (layer) {
                    callback(layer, index);
                }
            });
        }
    }

    /**
     * 设置样式
     * @param {Object} styles
     */
    set Styles(styles) {
        for (const key in styles) {
            const id = this._id + '.' + key;
            if (this._map && this._map.getLayer(id)) {
                const _styles = styles[key];
                // 添加样式
                for (const styleKey in _styles) {
                    if (hasOwnProperty(_styles, styleKey)) {
                        const value = _styles[styleKey];
                        this._map.setPaintProperty(id, styleKey, value);
                    }
                }
            }
        }
    }

    /**
     * 获取Features
     */
    get Features() {
        const features = this._source._data.features;
        return JSON.parse(JSON.stringify(features));
    }

    /**
     * 获取Bounds
     */
    get Bounds() {
        const features = this.Features;
        const len = features.length;
        const geometries = new Array(len);
        for (let i = 0; i < len; ++i) {
            geometries[i] = GeoGlobe.Feature.fromGeoJson(
                features[i]
            )[0].geometry;
        }
        const geom = new GeoGlobe.Geometry.Collection(geometries);
        geom.calculateBounds();
        return geom.bounds;
    }

    /**
     * 根据ID查询(id为自定义id)
     * @param {*} id
     * @returns {Array}
     */
    get(id) {
        const filterFeatures = this.Features.filter(
            f => f.id === id || f.properties.id === id
        );
        return filterFeatures;
    }

    /**
     * 添加feature
     * @param  {...any} rest
     */
    add(...rest) {
        this.setData([...this.Features, ...rest]);
    }

    /**
     * 删除Feature
     * @param {*} id
     */
    remove(id) {
        const filterFeatures = this.Features.filter(f => f.id !== id);
        this.setData(filterFeatures);
    }

    /**
     * 清空
     */
    clear() {
        this.setData([]);
    }

    /**
     * @api
     * 设置数据
     * @param {*} features
     */
    setData(features) {
        features = JSON.parse(JSON.stringify(features));
        this._source.setData({ type: 'FeatureCollection', features: features });
    }

    setMap(map) {
        if (map) {
            this._map = map;
            // 生成source
            const sourceId = this._id + '.' + 'source';
            const source = {
                type: 'geojson',
                data: { type: 'FeatureCollection', features: [] },
            };
            const heatlayer = {
                id: this._id + '.' + 'heat',
                type: 'heatmap',
                source: sourceId,
                minzoom: this._zoomRange[0],
                maxzoom: this._zoomRange[1],
                paint: {
                    // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
                    // Begin color ramp at 0-stop with a 0-transparancy color
                    // to create a blur-like effect.
                    'heatmap-color': [
                        'interpolate',
                        ['linear'],
                        ['heatmap-density'],
                        0,
                        'rgba(33,102,172,0)',
                        0.25,
                        'rgb(0,0,255)',
                        0.55,
                        'rgb(0,255,0)',
                        0.85,
                        'rgb(255,255,0)',
                        1,
                        'rgb(255,0,0)',
                    ],
                    'heatmap-radius': 20,
                    'heatmap-opacity': 0.6,
                    // 'heatmap-weight': ['get', 'hoverId']
                },
            };
            const pointlayer = {
                id: this._id + '.' + 'point',
                type: 'circle',
                source: sourceId,
                minzoom: this._zoomRange[0],
                maxzoom: this._zoomRange[1],
                paint: {
                    'circle-radius': 2,

                    'circle-color': 'rgb(0,0,255)',
                    'circle-stroke-color': 'white',
                    'circle-stroke-width': 0.1,
                    'circle-opacity': 0.2,
                },
            };
            // 添加source和layers
            map.addSource(sourceId, source);
            map.addLayer(pointlayer, this._group);
            map.addLayer(heatlayer, this._group);
            // 保存源source
            this._source = map.getSource(sourceId);
        } else {
            if (this._map) {
                map = this._map;
                delete this._source;
                map.removeLayer(this._id + '.' + 'heat');
                map.removeLayer(this._id + '.' + 'point');
                map.removeSource(this._id + '.' + 'source');
                delete this._map;
            }
        }
    }
}
